(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SubscriptionPackageDialogController', SubscriptionPackageDialogController);

    SubscriptionPackageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SubscriptionPackage', 'PackageFeatureList'];

    function SubscriptionPackageDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, SubscriptionPackage, PackageFeatureList) {
        var vm = this;

        vm.subscriptionPackage = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.packagefeaturelists = PackageFeatureList.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.subscriptionPackage.id !== null) {
                SubscriptionPackage.update(vm.subscriptionPackage, onSaveSuccess, onSaveError);
            } else {
                SubscriptionPackage.save(vm.subscriptionPackage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:subscriptionPackageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
